import {
  ENDPOINT_ROOT,
  ORDER_SEARCH_TERM_KEY_PARAM,
  TERM_KEY_PARAM,
} from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const getOrders = ({ queryKey }) => {
  const [endpoint, apiParams] = queryKey;

  const params = {
    ...apiParams,
    [ORDER_SEARCH_TERM_KEY_PARAM]: apiParams[TERM_KEY_PARAM],
  };

  delete params[TERM_KEY_PARAM];

  return axiosAuth
    .get(`${ENDPOINT_ROOT}/${endpoint}`, {
      params,
    })
    .then((res) => res.data);
};

export default getOrders;
